export default "__VITE_ASSET__4UrqB5tH__"